import React from 'react';

const SECTIONS = [
  { id: 'configuration', label: 'quote_builder_widget.section_configuration', icon: 'fa-cog' },
  { id: 'appearance', label: 'quote_builder_widget.section_appearance', icon: 'fa-paint-brush' },
  { id: 'carton_materials', label: 'quote_builder_widget.section_carton_materials', icon: null },
  { id: 'corrugated_materials', label: 'quote_builder_widget.section_corrugated_materials', icon: null },
];

const SettingsSidebar = ({ activeSection, onSectionChange }) => {
  const sidebarStyle = {
    width: '180px',
    minWidth: '180px',
    backgroundColor: '#f8f9fa',
    borderRight: '1px solid #dee2e6',
    padding: '0',
    alignSelf: 'stretch',
  };

  const navItemStyle = (isActive) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '14px 20px',
    cursor: 'pointer',
    backgroundColor: isActive ? '#fff' : 'transparent',
    borderLeft: isActive ? '3px solid #0d6efd' : '3px solid transparent',
    borderBottom: '1px solid #e9ecef',
    color: isActive ? '#0d6efd' : '#495057',
    fontWeight: isActive ? 600 : 400,
    fontSize: '14px',
    transition: 'all 0.15s ease',
  });

  const iconStyle = {
    width: '20px',
    textAlign: 'center',
  };

  return (
    <div style={sidebarStyle}>
      {SECTIONS.map((section) => (
        <div
          key={section.id}
          style={navItemStyle(activeSection === section.id)}
          onClick={() => onSectionChange(section.id)}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              onSectionChange(section.id);
            }
          }}
        >
          {section.icon && <i className={`fa ${section.icon}`} style={iconStyle} aria-hidden="true"></i>}
          <span>{t(section.label)}</span>
        </div>
      ))}
    </div>
  );
};

export default SettingsSidebar;
